import { defineMessages } from 'react-intl';

const messages = defineMessages({
  PriceProfiles: 'Price profiles',
  Name: 'Name',
  AssignedEmployees: 'Assigned employees',
  Default: 'Default',
  Delete: 'Delete',
  Add: 'Add',
  AddEmployeeProfile: 'Add employee profile',
  NewEmployeeProfile: 'New employee profile',
  DefaultProfile: 'Default profile',
  MakeDefaultProfile: 'Make this the default profile',
  ConfirmDeleteTitle: { id: 'comfirmDeleteTitle', defaultMessage: 'Confirm delete' },
  ConfirmDeleteEmployeeProfile: {
    id: 'msgConfirmDeleteEmployeeProfile',
    defaultMessage: 'Are you sure you want to delete this employee profile?',
  },
  ChangesSaved: { id: 'msgConfirmChange', defaultMessage: 'Changes saved' },
});

export default messages;
